import { gql } from "@apollo/client";

export default gql`
  mutation updateFaqOrder($ordering: [Int!]!) {
    updateFaqOrder(ordering: $ordering)
  }
`;
